module.exports = __webpack_public_path__ + "img/cek_tarif.bb3e8c75.svg";